module.exports = __webpack_public_path__ + "img/pwa-role-select-hen.98221732.png";